export default `#nice {
  background-color: #f5edcf;
  color: #4b4030;
  font-size: 16px;
  line-height: 1.85;
  letter-spacing: .02em;
  word-break: break-word;
  word-wrap: break-word;
  font-family: "STKaiti", "KaiTi", "FangSong", "仿宋", serif;
  padding: 0 12px;
  text-align: left;
}

#nice p {
  color: #4b4030;
  margin: 0;
  padding: 7px 0;
}

#nice h1,
#nice h2,
#nice h3,
#nice h4,
#nice h5,
#nice h6 {
  color: #8d3028;
  font-weight: 700;
  letter-spacing: .08em;
  line-height: 1.45;
}

#nice h1 {
  font-size: 26px;
  text-align: center;
  margin: 34px 0 24px;
  padding: 12px 0;
  border-top: 2px solid #b88a48;
  border-bottom: 2px solid #b88a48;
}

#nice h2 {
  font-size: 22px;
  margin: 28px 0 14px;
  padding-left: 14px;
  border-left: 5px solid #b64b36;
  border-bottom: 1px solid #c9a76a;
  padding-bottom: 6px;
}

#nice h3 {
  font-size: 19px;
  margin: 22px 0 10px;
  padding-bottom: 4px;
  border-bottom: 1px dashed #c9a76a;
}

#nice h4,
#nice h5,
#nice h6 {
  margin: 18px 0 8px;
}

#nice h1 .prefix,
#nice h2 .prefix,
#nice h3 .prefix,
#nice h4 .prefix,
#nice h5 .prefix,
#nice h6 .prefix,
#nice h1 .suffix,
#nice h2 .suffix,
#nice h3 .suffix,
#nice h4 .suffix,
#nice h5 .suffix,
#nice h6 .suffix {
  display: none;
}

#nice ul,
#nice ol {
  margin: 10px 0;
  padding-left: 28px;
}

#nice li section {
  color: #4b4030;
  line-height: 1.8;
  margin: 4px 0;
}

#nice blockquote {
  margin: 18px 0;
  padding: 10px 16px;
  color: #65533d;
  background: rgba(255, 250, 225, .62);
  border-left: 4px solid #b64b36;
  box-shadow: inset 0 0 0 1px rgba(184, 138, 72, .28);
}

#nice blockquote p {
  color: #65533d;
  padding: 0;
}

#nice a {
  color: #9d3f2f;
  font-weight: 700;
  text-decoration: none;
  border-bottom: 1px solid #b64b36;
}

#nice strong {
  color: #7f2f27;
}

#nice em {
  color: #72582e;
}

#nice del {
  color: #8a7a63;
}

#nice hr {
  height: 1px;
  margin: 22px 0;
  border: 0;
  background: #b88a48;
}

#nice p code,
#nice li code {
  color: #773b2c;
  background: #eadbb4;
  border: 1px solid #d0b477;
  border-radius: 3px;
  padding: 2px 5px;
  font-family: "Operator Mono", Consolas, Monaco, Menlo, monospace;
  font-size: 13px;
}

#nice pre {
  margin: 16px 0;
  padding: 14px 16px;
  overflow: auto;
  background: #302a22;
  border: 3px double #b88a48;
  border-radius: 2px;
}

#nice pre code {
  color: #f5edcf;
  font-family: "Operator Mono", Consolas, Monaco, Menlo, monospace;
  line-height: 1.65;
}

#nice img {
  display: block;
  max-width: 100%;
  margin: 14px auto;
  border: 4px solid #eadbb4;
  box-shadow: 0 0 0 1px #b88a48;
}

#nice figure {
  margin: 16px 0;
}

#nice figcaption {
  color: #8a6d42;
  font-size: 13px;
  text-align: center;
}

#nice table {
  border-collapse: collapse;
  margin: 16px 0;
  width: 100%;
}

#nice table tr th,
#nice table tr td {
  border: 1px solid #c9a76a;
  padding: 7px 10px;
  color: #4b4030;
}

#nice table tr th {
  color: #7f2f27;
  background: #eadbb4;
}

#nice .footnote-word,
#nice .footnote-ref,
#nice .footnote-num {
  color: #9d3f2f;
}

#nice .footnote-item p {
  color: #65533d;
}
`;
